import { isoZ, z } from 'my-zod'

export const corporateFleetVehicleCheckoutModel = z.object({
  id: z.string(),
  vehicleId: z.number(),
  employeeName: z.string(),
  employeeEmail: z.string(),
  eventName: z.string().nullable(),
  location: z.string().nullable(),
  checkOutReason: z.string().nullable(),
  checkOutDate: isoZ.instant(),
  checkOutMIleage: z.number().nullable(),
  checkOutEngineHours: z.number().nullable(),
  checkOutTreadDepth: z.number().nullable(),
  safetyAcknowledgements: z.boolean()
})

export type corporateFleetVehicleCheckoutModel = z.infer<typeof corporateFleetVehicleCheckoutModel>

export const corporateFleetVehicleCheckInModel = z.object({
  id: z.string(),
  vehicleId: z.number(),
  checkInDate: isoZ.instant(),
  checkInMIleage: z.number().nullable(),
  checkInEngineHours: z.number().nullable(),
  checkInTreadDepth: z.number().nullable(),
  safetyAcknowledgements: z.boolean()
})

export type corporateFleetVehicleCheckInModel = z.infer<typeof corporateFleetVehicleCheckInModel>

export const corporateFleetRecentCheckoutModel = z.object({
  id: z.string(),
  vehicleId: z.number(),
  employeeName: z.string(),
  employeeEmail: z.string(),
  eventName: z.string().nullish(),
  location: z.string().nullish(),
  checkOutReason: z.string().nullable().setLabel('Check-Out Reason'),
  checkOutDate: z.string().setLabel('Check-Out Date'),
  checkOutMIleage: z.number().nullable().setLabel('Check-Out MIleage'),
  checkOutEngineHours: z.number().nullable().setLabel('Check-Out Engine Hours'),
  checkOutTreadDepth: z.number().nullable().setLabel('Check-Out Tread Depth'),
  checkInDate: z.string().nullable().setLabel('Check-In Date'),
  checkInMIleage: z.number().nullable().setLabel('Check-In Mileage'),
  checkInEngineHours: z.number().nullable().setLabel('Check-In Engine Hours'),
  checkInTreadDepth: z.number().nullable().setLabel('Check-In Tread Depth'),
  safetyAcknowledgements: z.boolean()
})

export type corporateFleetRecentCheckoutModel = z.infer<typeof corporateFleetRecentCheckoutModel>
